/** @format */

import axios from 'axios';

import Notify from '../../../components/Commons/Notify';

import { ENV_USER } from '../../../components/Commons/Hooks/Variables/Enviroment';

export default async function confirmService(item) {
	let returnResponse;
	await axios({
		method: 'POST',
		url: `${ENV_USER}/user/confirm-token`,
		data: {
			token: item,
		},
	})
		.then((response) => {
			if (response.data.statusCode === 200) {
				Notify({
					title: 'Correo Electrónico confirmado',
					colorTitle: 'ph-main-notification-success-title',
					description: 'Disfruta de tus beneficios y comienza a comprar.',
					time: 3,
					image: 'warning',
					placement: 'topRight',
				});
				returnResponse = true;
			} else {
				Notify({
					title: 'Problema con Email',
					colorTitle: 'ph-main-notification-error-title',
					description: 'Su correo correo electrónico no está registrado.',
					time: 3,
					image: 'error',
					placement: 'topRight',
				});
			}
		})
		.catch(() => {
			Notify({
				title: `Error Servicio`,
				colorTitle: 'ph-main-notification-error-title',
				description: 'Problemas con el servicio - FUNCTION_USER restorePassword',
				time: 3,
				image: 'error',
				placement: 'topRight',
			});
		});
	return returnResponse;
}
